import { Head, useForm } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import {
  Field,
  FieldError,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import PartnerLayout from "@/layouts/partner-layout"
import { partnerAccountsPath } from "@/routes"

export default function NewAccount() {
  const { data, setData, post, processing, errors } = useForm({
    account: { name: "", industry: "" },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post(partnerAccountsPath())
  }

  return (
    <PartnerLayout>
      <Head title="New Account" />
      <div className="mx-auto w-full max-w-lg p-6">
        <h1 className="mb-6 text-2xl font-semibold">New Account</h1>
        <form onSubmit={handleSubmit}>
          <FieldGroup>
            <Field>
              <FieldLabel htmlFor="name">Account name</FieldLabel>
              <Input
                id="name"
                value={data.account.name}
                onChange={(e) =>
                  setData("account", { ...data.account, name: e.target.value })
                }
                required
                autoFocus
              />
              {errors["account.name"] && (
                <FieldError>{errors["account.name"]}</FieldError>
              )}
            </Field>
            <Field>
              <FieldLabel htmlFor="industry">Industry</FieldLabel>
              <Input
                id="industry"
                value={data.account.industry}
                onChange={(e) =>
                  setData("account", {
                    ...data.account,
                    industry: e.target.value,
                  })
                }
              />
            </Field>
            <Button type="submit" loading={processing}>
              Create account
            </Button>
          </FieldGroup>
        </form>
      </div>
    </PartnerLayout>
  )
}
